<template>
  <div class="w-full">
    <div class="rounded-[16px] bg-[#F6F4F0]">
      <div
        class="relative mx-auto w-[250px] h-[275px] md:w-[380px] md:h-[418px] lg:w-[460px] lg:h-[506px]"
      >
        <p
          v-if="isLoading"
          class="absolute text-[1rem] leading-[1.5rem] top-[110px] left-[90px] md:top-[175px] md:left-[150px] lg:top-[215px] lg:left-[185px] z-[3]"
        >
          Generating...
        </p>
        <img
          ref="canvasImg"
          class="mx-auto w-[250px] h-[275px] md:w-[380px] md:h-[418px] lg:w-[460px] lg:h-[506px]"
          :class="{
            'blur-img': isLoading,
          }"
        />
      </div>
      <div class="flex flex-row items-center justify-between pt-[32px]">
        <div
          class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.25rem] md:leading-[2rem] lg:leading-[2.25rem] text-[#000000] font-bold"
        >
          UEN: S99SS0059K
        </div>
        <p
          class="block p-[4px] rounded-[8px] bg-[#E5F0FF] cursor-pointer"
          @click="copyClipboard('generic-qr-code-copy-1', 'S99SS0059K')"
        >
          <svg
            class="inline"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 8H10C8.89543 8 8 8.89543 8 10V18C8 19.1046 8.89543 20 10 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z"
              stroke="#0D5DF5"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 8V6C16 5.46957 15.7893 4.96086 15.4142 4.58579C15.0391 4.21071 14.5304 4 14 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V14C4 14.5304 4.21071 15.0391 4.58579 15.4142C4.96086 15.7893 5.46957 16 6 16H8"
              stroke="#0D5DF5"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span
            id="generic-qr-code-copy-1"
            class="text-[0.875rem] md:text-[1.5rem] lg:text-[1.625rem] leading-[1.375rem] md:leading-[2rem] lg:leading-[2.25rem] text-[#0D5DF5] font-medium"
            >Copy</span
          >
        </p>
      </div>
      <div class="blur-img"></div>
    </div>
  </div>
</template>

<script>
import PaynowQR from 'paynowqr';

export default {
  props: {
    amount: {
      type: String,
      default: '1',
    },
    referenceText: {
      type: String,
      default: 'Offering',
    },
    givingType: {
      type: String,
      default: 'offering',
    },
  },
  data() {
    return {
      qrCodeStyledImage: null,
      isLoading: false,
      isMounted: true,
      objectUrl: null,
    };
  },
  computed: {
    paynowMiddleLogo() {
      switch (this.givingType) {
        case 'Tithe':
          return '/assets/images/my-giving/paynow/tithing-paynow-logo.png';
        case 'Building Fund':
          return '/assets/images/my-giving/paynow/bf-paynow-logo.png';
        case 'Heart Community Services':
          return '/assets/images/my-giving/paynow/hcs-paynow-logo.png';
        case 'Missions':
          return '/assets/images/my-giving/paynow/missions-paynow-logo.png';
        case 'GenerationS Fund':
          return '/assets/images/my-giving/paynow/gens-fund-paynow-logo.png';
        case 'Offering':
          return '/assets/images/my-giving/paynow/offering-paynow-logo.png';
        default:
          return '';
      }
    },
    paynowColor() {
      switch (this.givingType) {
        case 'Tithe':
          return '#242D8A';
        case 'Building Fund':
          return '#931B22';
        case 'Heart Community Services':
          return '#0CA19D';
        case 'Missions':
          return '#AE6700';
        case 'GenerationS Fund':
          return '#2C8156';
        case 'Offering':
          return '#86177D';
        default:
          return '';
      }
    },
  },
  mounted() {
    this.isMounted = true;
    this.isLoading = true;
    this.$nextTick(() => {
      this.initiatePayNowQRCodeStyler();
      const paynowQRCodeUTF8String = this.generatePayNowQRCodeUTF8String();
      this.generatePayNowQRCodeImageOnHTML(paynowQRCodeUTF8String);
      this.$emit('qr-code-image', this.qrCodeStyledImage);
    });
  },
  beforeUnmount() {
    this.isMounted = false;
    // Clean up object URL to prevent memory leaks
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  },
  methods: {
    initiatePayNowQRCodeStyler() {
      const QRCodeStyling = require('qr-code-styling');
      this.qrCodeStyledImage = new QRCodeStyling({
        width: 300,
        height: 300,
        type: 'canvas',
        dotsOptions: {
          color: this.paynowColor, // PayNow purple color
        },
        backgroundOptions: {
          color: '#ffffff', // White background
        },
        imageOptions: {
          crossOrigin: 'anonymous',
        },
      });
    },
    generatePayNowQRCodeUTF8String() {
      const HOGC_UEN = 'S99SS0059K';

      const payNowQRObj = new PaynowQR({
        uen: HOGC_UEN,
        amount: this.amount,
        editable: true,
        refNumber: this.referenceText,
      });
      const QRCodeUTF8String = payNowQRObj.output();
      return QRCodeUTF8String;
    },
    generatePayNowQRCodeImageOnHTML(QRCodeUTF8String) {
      this.qrCodeStyledImage.update({
        data: QRCodeUTF8String,
      });

      // Get the QR code canvas
      const qrCanvas = document.createElement('canvas');
      qrCanvas.width = 300;
      qrCanvas.height = 330; // Increase height to accommodate text
      const ctx = qrCanvas.getContext('2d');

      const qrImage = new Image();
      qrImage.crossOrigin = 'anonymous';

      this.qrCodeStyledImage
        .getRawData('png')
        .then(blob => {
          // Check if component is still mounted before proceeding
          if (!this.isMounted) {
            return;
          }

          const url = URL.createObjectURL(blob);
          this.objectUrl = url;
          qrImage.src = url;

          qrImage.onload = () => {
            // Check if component is still mounted before proceeding
            if (!this.isMounted) {
              return;
            }

            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, qrCanvas.width, qrCanvas.height);

            ctx.drawImage(qrImage, 0, 0);

            if (this.givingType !== 'offering') {
              ctx.font = '20px Arial';
              ctx.textAlign = 'center';
              ctx.fillStyle = '#000';
              ctx.fillText(
                `Ref no. ${this.referenceText}`,
                qrCanvas.width / 2,
                qrCanvas.height - 9,
              );
            }

            const logoImg = new Image();
            logoImg.src = this.paynowMiddleLogo;

            logoImg.onload = () => {
              // Check if component is still mounted and element exists before accessing DOM
              if (!this.isMounted) {
                return;
              }

              const centerX = 104;
              const centerY = 104;

              // Draw the image onto the canvas
              ctx.drawImage(logoImg, centerX, centerY, 98, 84);
              const pngDataUrl = qrCanvas.toDataURL('image/png');
              const imgElement = this.$refs.canvasImg;

              // Check if element exists before setting src
              if (imgElement) {
                imgElement.src = pngDataUrl;
                window.setTimeout(() => {
                  if (this.isMounted) {
                    this.isLoading = false;
                  }
                }, 500);
              }
            };
          };
        })
        .catch(error => {
          console.error('Failed to get QR code data:', error);
        });
    },
    async generateHighRes() {
      const QRCodeStyling = require('qr-code-styling');
      const paynowQRCodeUTF8String = this.generatePayNowQRCodeUTF8String();
      const highResQR = new QRCodeStyling({
        width: 960,
        height: 960,
        type: 'canvas',
        data: paynowQRCodeUTF8String,
        dotsOptions: {
          color: this.paynowColor,
        },
        backgroundOptions: {
          color: '#ffffff',
        },
        imageOptions: {
          crossOrigin: 'anonymous',
        },
      });
      const blob = await highResQR.getRawData('png');
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    },
    copyClipboard(id, target) {
      const element = document.getElementById(id);
      element.innerText = 'Copied';
      navigator.clipboard.writeText(target);
      setTimeout(() => this.removeCopyText(id), 1500);
    },
    removeCopyText(id) {
      const element = document.getElementById(id);
      element.innerText = 'Copy';
    },
  },
};
</script>

<style scoped lang="scss">
.blur-img {
  filter: blur(8px);
}
</style>
